export const returnToLastUrl = () => {
  try {
    window.history.go(-1);
  } catch {
    window.close();
  }
};
